import { createFileRoute } from '@tanstack/react-router'
import { ChatLab } from '@/features/lab/ChatLab'

export const Route = createFileRoute('/_app/app/lab/chat')({
  staticData: { crumb: { label: 'Chat' } },
  component: ChatLab,
})
